/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useMemo, useState } from "react";
import {
  Column,
  useTable,
  useSortBy,
  TableInstance,
  UseSortByColumnProps,
  HeaderGroup,
} from "react-table";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { LinearProgress } from "@material-ui/core";
import clsx from "clsx";
import axios from "axios";
import { setupCache } from "axios-cache-adapter";
import { useLocation } from "react-router-dom";
import "./styles.scss";
import { TeamCard, camelize } from "./TeamCard/team-card";
import { setRegionColor } from "../../components/RegionCard/region-card";
import { Dropdown } from "../../components/Dropdown/dropdown";
import { TeamInfo } from "./TeamInfo/team-info";

export interface Team {
  TeamID: number;
  Name: string;
  Region: string;
  Country: string;
  Section: string;
  Track: string;
  Latitude: string;
  Longitude: string;
}
interface TeamTable {
  Name: string;
  Region: string;
  Country: string;
  Section: string;
}
interface Location {
  Region: string;
  Country: string;
}
interface HeaderGroupType<D extends object = {}>
  extends HeaderGroup<D>,
    UseSortByColumnProps<D> {}

export const Teams = (): JSX.Element => {
  const { pathname } = useLocation();

  const cache = setupCache({
    maxAge: 15 * 60 * 1000,
  });
  const api = axios.create({
    adapter: cache.adapter,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [cardView, setCardView] = useState(true);
  const [teams, setTeams] = useState<Team[]>([]);
  const [itemError, setItemError] = useState<string>();
  const [filteredTeams, setFilteredTeams] = useState<Team[]>([]);
  const [uniqueLocations, setUniqueLocations] = useState<Location[]>([]);
  const [activeRegion, setActiveRegion] = useState<string>("");

  const columns = useMemo<Column<TeamTable>[]>(
    () => [
      {
        Header: "Team Name",
        accessor: "Name",
        Cell: (tableInfo) => (
          <div
            style={{
              borderColor: setRegionColor(
                tableInfo.data[tableInfo.row.index].Region
              ),
            }}
            className="table-cell indicator"
          >
            {tableInfo.data[tableInfo.row.index].Name}
          </div>
        ),
      },
      {
        Header: "Region",
        accessor: "Region",
        Cell: (tableInfo) => (
          <div className="table-cell">
            {tableInfo.data[tableInfo.row.index].Region}
          </div>
        ),
      },
      {
        Header: "Country*",
        accessor: "Country",
        Cell: (tableInfo) => (
          <div className="table-cell">
            {tableInfo.data[tableInfo.row.index].Country}
          </div>
        ),
      },
      {
        Header: "Kind",
        accessor: "Section",
        Cell: (tableInfo) => (
          <div className="table-cell">
            {tableInfo.data[tableInfo.row.index].Section}
          </div>
        ),
      },
    ],
    []
  );
  const data = useMemo<TeamTable[]>(() => [...filteredTeams], [filteredTeams]);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const renderTable = (table: TableInstance<TeamTable>) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = table;
    return (
      <table {...getTableProps()} className="table">
        <thead>
          {headerGroups.map((group) => (
            <tr {...group.getHeaderGroupProps()}>
              {group.headers.map((c) => {
                const column = (c as unknown) as HeaderGroupType<object>;
                return (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    {column.isSortedDesc ? (
                      <ArrowDropDownIcon />
                    ) : (
                      <ArrowDropUpIcon />
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} style={{ ...row.getRowProps().style }}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };
  useEffect(() => {
    api
      .get(
        "https://api.igem.io/api/openingWeekend/teamData?searchKeyword&Region&Country&Track&Section&Size&Status&Year"
      )
      .then((value) => {
        const teamsData = value.data.data;
        const cleanedTeamData: Team[] = teamsData.map(
          (team: { Country: string; Section: string }) => ({
            ...team,
            Country: camelize(team.Country.toLowerCase()),
            Section: team.Section === "High_school" ? "High School" : "",
          })
        );
        setTeams(cleanedTeamData);
        return true;
      })
      .catch(() => setItemError("Could not retrieve teams list"));
  }, []);

  useEffect(() => {
    setFilteredTeams(teams);
    const locations: Location[] = teams.map(
      (team: { Region: string; Country: string }) => ({
        Region: team.Region,
        Country: team.Country,
      })
    );
    setUniqueLocations(
      locations.filter(
        (location, index, self) =>
          self.findIndex(
            (t) =>
              t.Region === location.Region && t.Country === location.Country
          ) === index
      )
    );
  }, [teams]);

  const filterTeams = (name?: string, country?: string, region?: string) => {
    if (name) {
      setFilteredTeams(
        teams.filter((team: { Name: string }) => team.Name === name)
      );
      setActiveRegion("");
    } else if (country) {
      setFilteredTeams(
        teams.filter(
          (team: { Country: string }) =>
            team.Country.toLowerCase() === country.toLowerCase()
        )
      );
      setActiveRegion("");
    } else if (region) {
      setFilteredTeams(teams.filter((team) => team.Region === region));
    } else {
      setFilteredTeams(teams);
    }
  };

  const setRegion = (region: string) => {
    if (region === activeRegion) {
      setActiveRegion("");
      filterTeams();
    } else {
      setActiveRegion(region);
      filterTeams(undefined, undefined, region);
    }
  };

  return (
    <div className="tm">
      <h1>Teams</h1>
      <div className="tm-info">
        <div className="tm-wrapper">
          <TeamInfo
            onClick={(region) => setRegion(region)}
            activeRegion={activeRegion}
            countFallback={teams.length}
          />
          <div>
            <Dropdown
              items={teams.map((team) => ({
                id: team.TeamID,
                label: team.Name,
              }))}
              placeholder="Find team by name"
              onChange={(team) => filterTeams(team[0]?.label)}
              clearable
            />
            <Dropdown
              items={uniqueLocations.map((location, index) => ({
                id: index,
                label: camelize(location.Country.toLowerCase()),
              }))}
              placeholder="Choose country*"
              onChange={(country) => filterTeams(undefined, country[0]?.label)}
              clearable
            />
          </div>
        </div>
        <p className="country-info">
          * The term “country” in normal commercial use may refer to a country,
          region, province, or other economic area.
        </p>
      </div>
      <div className="tm-controls">
        <div className="tm-controls-view">
          <button
            type="button"
            onClick={() => setCardView(true)}
            className={clsx(cardView && "active")}
          >
            Card view
          </button>
          <button
            type="button"
            onClick={() => setCardView(false)}
            className={clsx(!cardView && "active")}
          >
            Table view
          </button>
        </div>
      </div>
      <div className="tm-items">
        {teams.length === 0 && !itemError ? (
          <div className="tm-loader">
            <LinearProgress />
          </div>
        ) : (
          <>
            {cardView ? (
              <ul>
                {filteredTeams
                  .sort((team1, team2) => team1.Name.localeCompare(team2.Name))
                  .map((team) => (
                    <TeamCard
                      key={team.TeamID}
                      name={team.Name}
                      region={team.Region}
                      country={team.Country}
                      track={team.Track}
                      setRegionColor={setRegionColor}
                    />
                  ))}
              </ul>
            ) : (
              renderTable(tableInstance)
            )}
          </>
        )}
      </div>
    </div>
  );
};
